var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPlayFill = function SvgPlayFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.409 21C4.564 21 4 20.389 4 19.433V4.567C4 3.61 4.564 3 5.409 3c.458 0 .833.156 1.315.411l12.996 7.122c.94.511 1.28.878 1.28 1.467 0 .589-.34.956-1.28 1.467L6.724 20.589c-.482.255-.857.411-1.315.411Z",
    fill: "currentColor"
  })));
};

export default SvgPlayFill;